module.exports = __webpack_public_path__ + "img/city-center-gray.e6f3f29b.svg";